
import React from "react";

interface LoadingViewProps {
  message?: string;
}

const LoadingView = ({ message = "Loading game data..." }: LoadingViewProps) => {
  return (
    <div className="px-4 flex items-center justify-center h-64">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">{message}</p>
      </div>
    </div>
  );
};

export default LoadingView;
